import { render, staticRenderFns } from "./activity-teacher.vue?vue&type=template&id=6abe9c14&scoped=true&"
import script from "./activity-teacher.vue?vue&type=script&lang=js&"
export * from "./activity-teacher.vue?vue&type=script&lang=js&"
import style0 from "./activity-teacher.vue?vue&type=style&index=0&id=6abe9c14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe9c14",
  null
  
)

export default component.exports